// @flow

/*
  Usage details and examples can be found here: <link>

  Things to think about:
  1. Should we combine find and query?
  2. How do we generalize the contents of finder?
  3. Should we reduce polymorphism by switching to findList/queryList?
  4. Should we update the join behavior to use a schema? (Non trivial, would need to be managed by query.)
  5. createEnt (along the lines of createStore)
  6. createLazySelector for find/join (currently find is always eager, join is always lazy)
*/

export type Entity = Object | Array<Object>;

export { default as find } from './find';
export { default as join } from './join';
export { default as query } from './query';
